import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { adminNavMenuLinks } from '../../constants/navMenuLinks';

class NavMenuLinks extends Component {
  static propTypes = {
    closeMobileAsideMenu: PropTypes.func,
    totalUnreadMessages: PropTypes.number.isRequired
  };

  render () {
    const { closeMobileAsideMenu, totalUnreadMessages } = this.props;
    return (
      <div>
        { adminNavMenuLinks.map((link, index) => (
          <NavLink className='menu-item' key={index} to={link.to} onClick={closeMobileAsideMenu}>
            <span className='icon-wrapper'>
              <FontAwesomeIcon size='lg' icon={link.icon} />
            </span>
            {link.title} {` `}
            {link.title === 'Messages' && !!totalUnreadMessages && (
              <span className='messages-count'>
               ({totalUnreadMessages})
              </span>
            )}
          </NavLink>
        ))}
      </div>
    );
  }
}

export default NavMenuLinks;



// WEBPACK FOOTER //
// ./src/components/navigation/NavMenuLinks.js